import * as React from "react";
import {ListGroup} from "react-bootstrap";
import {useReplacementPartsQuery} from "../../../../../hooks/useReplacementPartsQuery";
import { FaPlusCircle } from "react-icons/fa";

export const ReplacementParts = () => {
    const {model: {replacementParts, breakOutEarly, moreToShow, showAll}} = useReplacementPartsQuery();

    if (breakOutEarly) return <></>;

    return (
             <ListGroup variant="flush">
                <ListGroup.Item className="bg-light border-top">
                    <strong>Replacements</strong>
                </ListGroup.Item>
                {replacementParts.map(({product: {sku, title, path}}, index) => (
                    <ListGroup.Item action href={path} className="text-info" key={index}>
                        {title ?? sku}
                    </ListGroup.Item>
                ))}
                {moreToShow && (
                    <ListGroup.Item action  className="text-info d-flex align-items-center" onClick={showAll}>
                        <FaPlusCircle className="me-1" aria-hidden/>Show all {replacementParts.length} replacements
                    </ListGroup.Item>
                )}
            </ListGroup>
     );
};